module.exports = __webpack_public_path__ + "static/media/jmgraphic.d4feb9cb.svg";